<template>
  <v-card color="grey lighten-3">
    <v-card-text class="px-5 pt-5 pb-4">
      <v-layout wrap>
        <v-flex xs12>
          <v-text-field
            prepend-icon="cash-multiple"
            :rules="[(v) => !!v || 'Price is required']"
            v-model.number="form.promotion_fix_price"
            label="Fix product price (THB)"
            :disabled="isEditPromotion"
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-btn @click="includePartner()">Include all partner</v-btn>
          <v-btn @click="includeNoPartner()">Include all no partner</v-btn>
          <v-btn @click="clearStore()">Clear</v-btn>
          <v-text-field
            prepend-icon="search"
            label="Search store name"
            v-model="search"
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-layout row wrap v-for="(info, index) in searchStore" :key="index">
            <v-flex xs10 v-if="index < 10">
              <v-autocomplete
                prepend-icon="storefront"
                :value="info"
                @input="selectStore($event, countIndex(info) - 1)"
                :items="store_list_free"
                :loading="isLoading"
                color="black"
                hide-no-data
                hide-selected
                item-text="store_name_th"
                return-object
                label="Search store"
                placeholder="Select store"
                :rules="[rules.store_required, rules.store_already]"
                v-if="form.promotion_order_type == 3"
                :disabled="isEditPromotion"
              ></v-autocomplete>
              <v-autocomplete
                prepend-icon="storefront"
                :value="info"
                @input="selectStore($event)"
                :items="store_list"
                :loading="isLoading"
                color="black"
                hide-no-data
                hide-selected
                item-text="store_name_th"
                return-object
                label="Search store"
                placeholder="Select store"
                :rules="[rules.store_required, rules.store_already]"
                v-else
                :disabled="isEditPromotion"
              ></v-autocomplete>
            </v-flex>
            <v-flex
              xs2
              class="text-xs-center pt-4"
              v-if="!isEditPromotion && index < 10"
            >
              <v-icon
                medium
                color="green"
                @click="moreStore()"
                v-if="countIndex(info) - 1 == 0"
                >add_box</v-icon
              >
              <v-icon
                medium
                color="red"
                @click="lessStore(countIndex(info) - 1)"
                v-else
                >indeterminate_check_box</v-icon
              >
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <div class="text-xs-center">
        Total store: {{ promotion_stores.length }}
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  props: ["promotion_stores", "form", "province"],
  data() {
    return {
      isLoading: false,
      search: "",
      rules: {
        store_required: (value) =>
          (!!value && value.store_id != 0) || "Required.",
        store_already: (value) =>
          value.store_id != -1 || "Store already to select.",
      },
    };
  },
  watch: {},
  computed: {
    ...mapGetters({
      store_list_free: "fetchStoreBack/autocompleteStoreFreedelivery",
      store_list: "fetchStoreBack/autocompleteStore",
      isEditPromotion: "isEditPromotion",
    }),
    searchStore() {
      // console.log(1);
      if (this.search == "") {
        return this.promotion_stores;
      } else {
        return this.promotion_stores.filter((val) => {
          if (val.store_id == 0 || val.store_id == -1) {
            return true;
          } else {
            return val.store_name_th.includes(this.search);
          }
        });
      }
    },
  },
  methods: {
    clearStore() {
      this.$emit("clearInclude");
    },
    includePartner() {
      this.$emit("include");
    },
    includeNoPartner() {
      this.$emit("includeNo");
    },
    selectStore(value, index) {
      let payload = {
        value,
        index,
      };
      this.$emit("select", payload);
    },
    countIndex(info) {
      return (
        this.promotion_stores.findIndex((val) => {
          return val.store_id == info.store_id;
        }) + 1
      );
    },
    moreStore() {
      if (
        this.promotion_stores.length > 0 &&
        (this.promotion_stores[0].store_id == 0 ||
          this.promotion_stores[0].store_id == -1)
      )
        return;

      this.promotion_stores.unshift({ store_id: 0 });
    },
    lessStore(index) {
      this.promotion_stores.splice(index, 1);
    },
    // async initialzation() {
    //   if (this.isLoading) return;
    //   this.isLoading = true;
    //   await this.$store.dispatch("fetchStoreBack/getStoreList");
    //   this.isLoading = false;
    // },
  },

  created() {
    // this.initialzation();
  },
};
</script>

<style>
</style>
